'use strict';

var React = require('react');
var component$1 = require('../Tooltip/component.js');
var component = require('./component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const IconWithTooltip = ({ name, size, label, tooltipPlacement = 'bottom', ...additionalProps }) => {
    const targetRef = React.useRef(null);
    const [isTootlipOpen, setIsTooltipOpen] = React.useState(false);
    const onMouseEnter = () => setIsTooltipOpen(true);
    const onMouseLeave = () => setIsTooltipOpen(false);
    return (React__default.default.createElement(React__default.default.Fragment, null,
        React__default.default.createElement(component.Icon, { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, name: name, size: size, ref: targetRef, ...additionalProps }),
        isTootlipOpen && label && typeof label === 'string' ? (React__default.default.createElement(component$1.Tooltip, { placement: tooltipPlacement, target: targetRef.current, isOpened: isTootlipOpen, onOpenedChange: setIsTooltipOpen }, label)) : null));
};

exports.IconWithTooltip = IconWithTooltip;
//# sourceMappingURL=iconWithTooltip.js.map
